import { Icon } from "@blueprintjs/core"
import Paper from "components/Atoms/Paper"
import DraggableBigCalendar from "components/Molecules/DraggableBigCalendar"
import dayjs from "dayjs"
import { useRouteAssignmentReccurencesQuery } from "generated/graphql"
import React, { useEffect, useMemo, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import AppToaster from "utils/AppToaster"
import dayjsLocalizer from "utils/dayjsLocalizer"
import useSalesManColorMap from "./salesman-colours.store"
import ShiftBeat, { EventType } from "./ShiftBeat"

const BeatCalendar = () => {
  const [params, setParams] = useSearchParams()
  const [changeBeat, setBeatToChange] = useState<EventType>(null)
  const date = params.get("date")
  const startDate = date || params.get("start")
  const endDate = date || params.get("end")
  const salesman = params.getAll("salesman")
  const search = params.get("search")
  const navigate = useNavigate()
  const { data, refetch } = useRouteAssignmentReccurencesQuery({
    variables: {
      start: `${startDate}T00`,
      end: `${endDate}T00`,
      query: search,
      filter: {
        assigneeIds: salesman,
      },
    },
  })
  const colorMap = useSalesManColorMap(store => store.colors)

  const assignments = data?.allRouteAssignments
  const events = useMemo(() => {
    const newEvents = []
    if (!assignments?.length) return newEvents
    for (const assignment of assignments) {
      for (const recurrence of assignment.recurrences) {
        newEvents.push({
          ...assignment,
          allDay: true,
          title: assignment.route.name,
          start: dayjs(recurrence).set("hour", 0).toDate(),
          end: dayjs(recurrence).set("hour", 23).toDate(),
        })
      }
    }
    return newEvents
  }, [assignments])

  useEffect(() => {
    if (!startDate && !endDate) {
      params.set("start", dayjs().startOf("month").format("YYYY-MM-DD"))
      params.set("end", dayjs().endOf("month").format("YYYY-MM-DD"))
      setParams(params, { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <Paper className="w-4/5 xl:w-5/6 p-3">
      <DraggableBigCalendar
        localizer={dayjsLocalizer}
        onEventDrop={args => {
          const event = args.event as any
          if (
            dayjs(args.end).format("YYYY-MM-DD") ===
            dayjs(event.start).format("YYYY-MM-DD")
          ) {
            return
          }
          setBeatToChange({
            id: event.id,
            routeName: event.route.name,
            assigneeName: event.assignee.fullName,
            include: args.end,
            exclude: event.start,
          })
        }}
        eventPropGetter={event => {
          const assigneeId = (event as any).assignee.id
          const color = colorMap[assigneeId]

          return {
            className: `bg-${color}-100 text-${color}-600`,
          }
        }}
        components={{
          event(args) {
            const event = args.event as any
            const id = event.id
            return (
              <div
                className="flex justify-between"
                onClick={e => {
                  e.stopPropagation()
                  navigate(id)
                }}
              >
                {event.title}
                <Icon
                  onClick={e => {
                    e.stopPropagation()
                    setBeatToChange({
                      id: event.id,
                      routeName: event.route.name,
                      assigneeName: event.assignee.fullName,
                      exclude: event.start,
                    })
                  }}
                  icon="cross"
                />
              </div>
            )
          },
        }}
        events={events}
        onRangeChange={range => {
          if (Array.isArray(range)) return
          params.set("start", dayjs(range.start).format("YYYY-MM-DD"))
          params.set("end", dayjs(range.end).format("YYYY-MM-DD"))
          setParams(params)
        }}
        // onNavigate={date => {
        //   params.set("date", dayjs(date).format("YYYY-MM-DDT00"))
        //   setParams(params)
        // }}
      />
      <ShiftBeat
        event={changeBeat}
        onClose={() => setBeatToChange(null)}
        onCompleted={() => {
          AppToaster.show({
            message: `Beat updated successfully!`,
            intent: "success",
            icon: "tick",
          })
          refetch()
          setBeatToChange(null)
        }}
      />
    </Paper>
  )
}

export default BeatCalendar
